import CardChart from "../../components/Cards/CardChart";
import ProductTable from "../../components/Table/Product/ProductTable";
import { useLogs, useItems, useFetch } from "../../hooks/useFetch";
import Table from "../../layouts/Table";
import { useMemo } from "react";
import { IProduct, OutletType } from "../../types";
import { ILog } from "../../types/logType";
import { IUser } from "../../types/userType";

const UserStatus = ({ context }: OutletType<IUser>) => {
	// const context = useOutletContext<IUser>();

	const [activities] = useFetch(
		useMemo<Partial<ILog>>(() => {
			return { user: context._id };
		}, [context]),
		"count"
	);

	const [products] = useFetch(
		useMemo<Partial<ILog>>(() => {
			return { user: context._id, category: "product" };
		}, [context]),
		"group"
	);

	const chatOps = useMemo<Partial<ILog>>(() => {
		return { action: "chat", user: context._id };
	}, [context]);
	const [chatLogs] = useLogs(chatOps, 5);
	const [chated, , load] = useItems<IProduct>(chatLogs);

	const likeOps = useMemo<Partial<ILog>>(() => {
		return { action: "like", user: context._id };
	}, [context]);

	const [likeLogs] = useLogs(likeOps, 5);
	const [liked, , loads] = useItems<IProduct>(likeLogs);

	const viewOps = useMemo<Partial<ILog>>(() => {
		return { action: "page", user: context._id };
	}, [context]);

	const [viewLogs] = useLogs(viewOps, 5);
	const [viewed, , loading] = useItems<IProduct>(viewLogs);

	return (
		<div className="relative grid gap-y-10">
			<div className="grid grid-cols-10 gap-x-10">
				<CardChart
					type="line"
					className="col-span-6"
					theme="dark"
					title="Activities"
					subtitle="insight"
					hover={false}
					data={activities}
				/>
				<CardChart
					className="col-span-4"
					theme="light"
					title="Product interaction"
					type="doughnut"
					hover={false}
					data={products}
				/>
			</div>
			{/* <div>
        <CardChart theme="dark" type="bar" hover={false} data={x} />
      </div> */}
			<Table
				title="Chat Product"
				icon="fas fa-comment-dots"
				iconColor="text-emerald-500"
				loading={load}
			>
				<ProductTable filter={["growth"]} data={chated}></ProductTable>
			</Table>
			<Table
				title="Liked Product"
				icon="fas fa-heart"
				iconColor="text-red-500"
				loading={loads}
			>
				<ProductTable filter={["chat"]} data={liked}></ProductTable>
			</Table>
			<Table
				title="Viewed Product"
				icon="fas fa-eye"
				iconColor="text-purple-500"
				loading={loading}
			>
				<ProductTable
					filter={["chat", "status", "growth"]}
					data={viewed}
				></ProductTable>
			</Table>
		</div>
	);
};

export default UserStatus;
